const versoes = [
  {
    versao: "3.6.5",
    data: "28/01/2026",
    melhorias: [
      "[TAF] Relatório agora tem status mais completos",
      "[TAF] Adicionar responsáveis sem email",
      "[TAF] Alterar grandezas de corrente e tensão",
      "[SGI] Registros do tipo Lições aprendidas",
      "[SGI] Finalizar automaticamente itens relacionados ao registro de reincidência",
      "[CHECKLIST] Agrupamento de checklists por proposta",
      "[CHECKLIST] Visualizar imagens de ocorrências no modal de edição",
      "[CHECKLIST] Duplo click para abrir na tabela de ocorrências",
    ],
    bug: [
      "[TAF] Assinaturas não eram geradas em ticket sem inspeção do cliente no local",
      "[SGI] Problemas no envio de email para fornecedor",
    ],
  },
  {
    versao: "3.6.3",
    data: "04/12/2025",
    melhorias: [
      "[SGI] Dashboard para gestão de indicadores de todos os pilares",
      "[SGI] Correções menores de usabilidade",
      "[RDO] Adicionar campo para comentários de fiscal do cliente",
      "[CHECKLIST] Tela de pendencias e evidencias aberta ao publico através do QRCode",
      "[CHECKLIST] Visualizar vídeos diretamente do sistema sem a necessidade de download",
    ],
    bug: ["[CHECKLIST] Problemas ao exportar a tabela"],
  },
  {
    versao: "3.6.2",
    data: "14/11/2025",
    melhorias: [
      "[CHECKLIST] Exportar lista de pendências para PDF",
      "[CHECKLIST] Visualização de fotos de pendências por QRCode",
      "[CHECKLIST] Adicionar checkbox para feito e verificado",
      "[CHECKLIST] Melhorar nomenclatura de formulários e seleções",
      "[CHECKLIST] Visualizar miniatura de imagens enviadas",
      "[CRE FÁBRICA] Mudança automática para LPF ao finalizar projetos chaves ",
      "[CRE] Importação de arquivos em massa",
      "[CRE] Novo status 'INFORMATIVO' para projetos",
      "[CRE] Botão para exclusão de arquivos de projetos",
      "[SGI] Aba para visualizar todos os itens em apenas um lugar",
      "[SGI] Filtro para visualizar apenas RNC e apenas DESVIO",
    ],
    bug: ["[CHECKLIST] Problemas de envio de arquivos de evidências"],
  },
  {
    versao: "3.6.1",
    data: "03/11/2025",
    melhorias: [
      "[CHECKLIST] Módulo para controle de checklist de qualidade para fábrica",
      "[CHECKLIST] Controle de evidencias de não conformidade e observações",
      "[CHECKLIST] Controle de evidencias de resolução de problemas",
      "[CHECKLIST] Visualização de checklists abertas e finalizadas dentro de cada produto",
      "[SGI] Certificado de qualidade emitido com assinatura automática",
      "[RDO] Importação de RDOs em massa",
    ],
    bug: [
      "[POS-VENDAS] Correção de graficos e filtros do dashboard",
      "[RDO] Erros ao salvar um novo RDO",
      "[RDO] Problemas para editar RDOs antigos",
      "[OBRA] Problemas ao editar informações de obras",
    ],
  },
  {
    versao: "3.6.0",
    data: "03/11/2025",
    melhorias: [
      "[CHECKLIST] Módulo para controle de checklist de qualidade para fábrica",
      "[CHECKLIST] Controle de evidencias de não conformidade e observações",
      "[CHECKLIST] Controle de evidencias de resolução de problemas",
      "[CHECKLIST] Visualização de checklists abertas e finalizadas dentro de cada produto",
      "[SGI] Certificado de qualidade emitido com assinatura automática",
      "[RDO] Importação de RDOs em massa",
    ],
    bug: [
      "[POS-VENDAS] Correção de graficos e filtros do dashboard",
      "[RDO] Erros ao salvar um novo RDO",
      "[RDO] Problemas para editar RDOs antigos",
      "[OBRA] Problemas ao editar informações de obras",
    ],
  },
  {
    versao: "3.5.3",
    data: "16/09/2025",
    melhorias: [
      "[SGI] Itens não procedentes vão para 'lixeira'",
      "[SGI] Novo status 'AGUARDANDO LIÇÕES APRENDIDAS'",
      "[SGI] Adicionar campo RESUMO para sugestões de melhoria",
      "[SGI] Adicionar natureza 'DESVIO'",
      "[SGI] Emails em cópia podem visualizar o plano de ação",
      "[SISTEMA] Melhoria nas permissões de usuários",
      "[SISTEMA] Melhoria na tela de cadastro de usuários",
    ],
    bug: ["[SGI] Erro no envio de arquivos"],
  },
  {
    versao: "3.5.2",
    data: "02/09/2025",
    melhorias: [
      "[GARANTIA] Emissão do certificado de garantia para produtos Gali",
      "[POS VENDAS] Envio de anexo junto aos emails externos para clientes",
      "[RIT] Correção das tabelas no celular",
      "[RIT] Edição de imagens antes do envio",
      "[RIT] Edição das fotos e descrições",
      "[RIT] Excluir imagens enviadas",
      "[RIT] Integração com o SGI",
      "[SGI] Todos emails enviados pelo @progali",
      "[SGI] Feedback de exclusão de arquivos",
      "[SGI] Desativar fluxo de envio automatico para qualidade",
      "[SGI] Adicionar natureza 'DESVIO'",
      "[SGI] Adicionar causas macro de fornecedores",
    ],
    bug: [
      "[SGI] Erro no envio de arquivos",
      "[SGI] Baixar arquivos anexados",
      "[SGI] Problemas de acesso de clientes pelo portal",
      "[CRE] Documentos de clientes enviados para pasta AsBuilt",
      "[RDO] Bugs menores",
    ],
  },
  {
    versao: "3.5.1",
    data: "18/08/2025",
    melhorias: [
      "[RIT] Atualizar cabecalho do relatório de inspeção técnica",
      "[RIT] Não mostrar itens N/A no relatório final",
      "[RIT] Remover e enviar novas fotos do relatório final",
      "[RIT] Editar observações ",
      "[SGI] Melhorias no fluxo de RNCs de fornecedores",
      "[SGI] Anexar mais de uma foto no envio de evidências pelo formulário",
      "[SGI] Disponibilizar ações e campos de RNC para todos os tipos de registros",
      "[JURÍDICO] Seleção de intervalo de datas para relatórios",
      "[JURÍDICO] Seleção de obras para relatórios",
    ],
    bug: [
      "[SGI] Correção no envio de evidências",
      "[SGI] Correção no controle de acesso de meio ambiente",
      "[RIT] Tabela de instrumentos trazendo informações trocadas",
    ],
  },
  {
    versao: "3.5.0",
    data: "08/08/2025",
    melhorias: [
      "[PÓS-VENDAS] AI para automação de email de pós-vendas",
      "[PÓS-VENDAS] Seleção de múltiplos meses para relatório de custos",
      "[PÓS-VENDAS] Indicador de dias úteis para conclusão do ticket",
      "[PÓS-VENDAS] Semáforo e controle de primeira interação humanizada",
      "[SGI] Excluir arquivos enviados incorretamente",
      "[SGI] Email de aviso de novo registro feito pelo portal de acordo com os pilares",
      "[SGI] Consolidação de emails para fornecedores",
      "[SGI] Controle de envio de emails para responsáveis",
      "[SGI] Melhorias no fluxo de RNCs de fornecedores",
      "[CRE] Adicionar link do drive nos emails de projeto",
      "[JURÍDICO] Dashboard de processos com filtros e gráficos",
    ],
    bug: ["[SGI] Correção de problemas ao salvar registros"],
  },
  {
    versao: "3.4.6",
    data: "09/06/2025",
    melhorias: [
      "[SGI] Adicionar grau de gravidade aos desvios",
      "[SGI] Melhorias no formulário de desvios",
      "[CONTRATOS] Adicionar gráfico de status de produtos, com drilldown",
      "[CONTRATOS] Adicionar dashboard de todos os produtos para um cliente",
      "[CONTRATOS] Atualizar Produtos ao atualizar uma fabricação",
      "[CONTRATOS] Adicionar gerente de logistica a matriz de responsabilidades",
      "[CONTRATOS] Deletar produtos ao deletar uma fabricação",
      "[CRE] Adicionar legenda aos gráficos",
      "[CRE] Deletar projetos",
      "[POS VENDAS] Remover avaliação do formulário de abertura",
      "[PÓS VENDAS] Colocar resumo no topo da página",
      "[PÓS VENDAS] Melhorias do formulário de abertura",
      "[PÓS VENDAS] Adicionar manual de instruções na abertura de tickets",
    ],

    bug: [
      "[BIBLIOTECA] Breadcrumbs de biblioteca quebram em janelas menores",
      "[CRE] Problemas na deleção de projetos ",
      "[CONTRATOS] Produtos duplicados",
      "[PÓS VENDAS] Problemas na criação de novos tickets pelo formulário externo",
    ],
  },

  {
    versao: "3.4.5",
    data: "26/05/2025",
    melhorias: [
      "[CRE] Fluxos específicos para aprovação com e sem comentário do cliente",
      "[CRE] Controle interno de arquivos de reprovação",
      "[CONTRATOS] Atalho para lista de produtos dentro da lista de projetos",
      "[CONTRATOS] Excluir produtos de contratos",
      "[SGI] Portal de novos registros para todos os pilares de SGI ",
      "[SGI] Telas especificas para cada pilar de SGI ",
      "[POS VENDAS] Controle de custos comerciais de operação",
      "[POS VENDAS] Novas regras de validação do formulário de abertura",
    ],

    bug: [
      "[CONTRATOS] Produtos duplicados",
      "[CRE] Projetos não estavam correlacionando com produtos",
      "[POS VENDAS] Pesquisas duplicadas",
      "[SISTEMA] Problemas de ordenação das tabelas",
    ],
  },
  {
    versao: "3.4.4",
    data: "13/05/2025",
    melhorias: [
      "[CRE] Remover botão de salvar na aba de arquivos",
      "[SGI] Adequações do formulário SGI ",
      "[CONTRATOS] Opção de remover produtos cadatrados",
      "[SGI] Proteção de busca de RNCs internas",
      "[SGI] Padronização e salvamento automático de campos",
      "[SGI] Rastreabilidade de mudanças nos registros",
      "[SGI] Excluir ações corretivas e preventivas",
      "[POS VENDAS] Alterar email de aviso de pesquisa de satisfação",
      "[POS VENDAS] Adicionar campo 'outros' no formulário de abertura",
      "[JURIDICO] Remover arquivos enviados pelos responsáveis",
      "[JURIDICO] Escritórios parceiros podem enviar comentários",
      "[RDO] Busca de RDOs por atividade realizada",
    ],

    bug: [
      "[BIBLIOTECA] Mudar nome de pastas na biblioteca geral",
      "[BIBLIOTECA] Correção de problemas relacionados a paralelismo de sessões",
    ],
  },
  {
    versao: "3.4.3",
    data: "28/04/2025",
    melhorias: [
      "[PROGALI]  Redirecionamento para última tela utilizada, após login",
      "[PROGALI] Filtro por intervalo para colunas do tipo data",
      "[OBRAS] Adicionar gráfico de HISTOGRAMA de MO e Equipamentos",
      "[RDO] Indicadores de ocorrências na lista de RDOs",
      "[BIBLIOTECA] Alterar nomes das pastas",
      "[JURIDICO] Adicionar campo para RESUMO da defesa",
      "[JURIDICO] Compartilhar informações com equipe de segurança",
      "[JURIDICO] Portal para parceiros de acompanhamento de processo",
      "[POSVENDAS] Refatorar o formulário de abertura",
      "[POSVENDAS]  Adicionar mais de um email para responsáveis",
    ],
    bug: [
      "[POS VENDAS] Texto de interações somem",
      "[POS VENDAS] LEGENDA SOBREPONDO GRAFICOS",
      "[POS VENDAS] Resposta de satisfação retornando NaN",
      "[SGI] Portal de RNC",
    ],
  },
  {
    versao: "3.4.2",
    data: "07/04/2025",
    melhorias: [
      "[PLANEJAMENTO FÁBRICA] Aba de projetos relacionados a produtos",
      "[PLANEJAMENTO FÁBRICA] Adicionar campos de projeto mecânico e elétrico",
      "[PLANEJAMENTO FÁBRICA] Adicionar novos campos no cadastro de uma fabricação",
      "[PLANEJAMENTO FÁBRICA] Justificativa e causa macro de alterações de data de TAF",
      "[PLANEJAMENTO FÁBRICA] Implementação de avisos segundo matriz de responsabilidades",
      "[PROJETO FÁBRICA] Botão para excluir projetos em AE",
      "[PÓS-VENDAS] Feedback e carregamento de interações com sistema",
      "[JURÍDICO] Proteção com senha do portal para escritórios parceiros",
    ],
    bug: ["[PROJETO FÁBRICA] Não estava salvando quem alterou o projeto"],
  },
  {
    versao: "3.4.1",
    data: "25/03/2025",
    melhorias: [
      "[JURÍDICO] Adicionar mais de um email para escritórios",
      "[JURÍDICO] Ordenação por data da interação",
      "[JURÍDICO] Campo de nome de obra autopreenchido",
      "[PLANEJAMENTO FÁBRICA] Adicionar campos de datas automáticas controlados pelo TAF",
      "[PLANEJAMENTO FÁBRICA] Ordenação pelo TAF previsto",
      "[PLANEJAMENTO FÁBRICA] Indicativo visual de ultimas datas alteradas na tabela",
      "[PLANEJAMENTO FÁBRICA] Salvar e visualizar LOG de mudanças com indicativo visual de itens alterados",
      "[PÓS-VENDAS] Gráfico de custos por categoria",
      "[PÓS-VENDAS] Melhorias no campo de obras",
      "[PÓS-VENDAS] Indicador de dias úteis desde o inicio de atendimento",
      "[PROJETO FÁBRICA] Atribuição de produtos a projetos para acompanhamento",
      "[SGI] Portal para fornecedores",
    ],
    bug: [
      "[SGI] Envio não era enviado ao responsável após o salvamento do item",
      "[SGI] Correções nos emails enviados",
      "[SGI] Itens criados com status 'EM ANDAMENTO' devem receber ID sequencial",
    ],
  },
  {
    versao: "3.4.0",
    data: "13/03/2025",
    melhorias: [
      "[PÓS-VENDAS] Gráfico de chamados x clientes",
      "[PÓS-VENDAS] Transformar o campo de comentários em obrigatório",
      "[PÓS-VENDAS] Botão para reenviar a pesquisa de satisfação",
      "[PÓS-VENDAS] Alteração do email automático enviado para os clientes",
      "[SGI] Semáforo para datas de vencimento, conforme status",
      "[SGI] Alterações no tratamento de itens de RNC",
      "[PROJETO FÁBRICA] Preencher data prevista automaticamente",
      "[JURÍDICO] Permissões de exclusão ",
      "[JURÍDICO] Semáforo conforme status e condições",
      "[JURÍDICO] Portal para escritórios parceiros fazerem download e envio de documentos",
      "[BIBLIOTECA] Salvar níveis de acesso de forma Hereditária",
      "[PLANEJAMENTO FÁBRICA] Cadastrar/Controlar produtos por contrato",
      "[PLANEJAMENTO FÁBRICA] Alterar datas de TAF previsto",
      "[PLANEJAMENTO FÁBRICA] Alterar status de produtos conforme status de produção",
    ],
    bug: [
      "[BIBLIOTECA] Não é possível remover permissão da GALI",
      "[SISTEMA] Salvar preferencias do usuário",
      "[PROJETO FÁBRICA] Envio de email para coordenador de projetos",
    ],
  },
  {
    versao: "3.3.3",
    data: "24/02/2025",
    melhorias: [
      "[PÓS-VENDAS] Adicionar causa macro",
      "[PÓS-VENDAS] Adicionar área causadora e setor causador",
      "[PÓS-VENDAS] Exportar gráficos do dashboard para PNG",
      "[PÓS-VENDAS] Dashboard para acompanhamento de pesquisas de satisfação",
      "[PÓS-VENDAS] Gráfico de Tickets por produto Gali",
      "[SGI] Juntar itens de fábrica e manufatura",
      "[SGI] Disponibilizar arquivos enviados para o responsável do setor",
      "[SGI] Salvar dados de causa macro para preenchimentos futuros",
      "[SGI] Finalizar uma ocorrência após todas ações serem finalizadas",
      "[SGI] Registrar por qual portal a ocorrência foi criada",
      "[JURÍDICO] Ordenação padrão pelo nome do reclamante",
      "[JURÍDICO] Responsáveis podem enviar documentos não previamente listados",
      "[JURÍDICO] Botão para reenviar email de acesso para responsáveis",
      "[JURÍDICO] Enviar mais de um arquivo por documentos solicitado",
      "[JURÍDICO] Selecionar mais de um item nos pedidos",
      "[JURÍDICO] Email com informações mais completas",
      "[BIBLIOTECA] Opção de exclusão de pasta vazia",
      "[BIBLIOTECA] Salvar níveis de acesso de forma Hereditária",
    ],
    bug: [
      "[SGI] Email de reposição não estava sendo enviado",
      "[SEGUROS] Problemas na busca",
    ],
  },
  {
    versao: "3.3.2",
    data: "10/02/2025",
    melhorias: [
      "[PÓS-VENDAS] Gráfico de satisfação reflete apenas o responsável do ticket",
      "[PÓS-VENDAS] Remover pesquisa de satisfação do responsável de obra",
      "[PÓS-VENDAS] Adicionar categorias as custos de operação",
      "[PÓS-VENDAS] Espelhar campos do SGI",
      "[SGI] Responsável do setor agora preenche a causa raiz e plano de ação",
      "[SGI] Salvar dados do campo 'proposta' para auto-preenchimento futuro",
      "[SGI] Integração Pós-vendas",
      "[JURÍDICO] Conceder acesso de leitura para controladoria",
      "[JURÍDICO] Adicionar campo de instruções para pedido de arquivos",
      "[JURÍDICO] Receber avisos de arquivos enviados",
      "[JURÍDICO] Validação dos campos do formulário",
    ],
    bug: [
      "[SGI] Arquivos que não fazem parte do registro estão sendo mostrados na lista",
      "[JURÍDICO] Transformar valor da causa em numero decimal",
    ],
  },
  {
    versao: "3.3.1",
    data: "27/01/2025",
    melhorias: [
      "[CLIENTE CRE] Upload de arquivos e comentários",
      "[SGI] Enviar email com as peças e quantidades, quando ação imediata for Reposição",
      "[SGI] Enviar DESVIO para ANÁLISE DE QUALIDADE quando preenchido ação imediata",
      "[SGI] Separar itens por status, TRIAGEM, ANDAMENTO E FINALIZADO",
      "[SGI] Link direto para itens de SGI pelo email",
      "[SGI] Adicionar múltiplos itens para reposição ",
      "[SGI] Adicionar status RASCUNHO para itens preenchidos parcialmente",
      "[JURÍDICO] Aba de arquivos para processos civil",
      "[JURÍDICO] Link criptografado para envio de arquivos",
      "[JURÍDICO] Reordenar campos para melhor leitura e busca",
      "[JURÍDICO] Registro e controle de movimentações dos processos",
    ],
    bug: [
      "[SGI] Clicar duas vezes para criar RNC de recorrência",
      "[CLIENTES] Erro ao adicionar permissões para múltiplas obras",
      "[JURÍDICO] Problemas para voltar na aba anterior do formulário de cadastro",
    ],
  },
  {
    versao: "3.3.0",
    data: "08/01/2025",
    melhorias: [
      "[JURÍDICO] Criar e editar processos jurídicos",
      "[JURÍDICO] Solicitar documentação e receber documentação das áreas pertinentes",
      "[JURÍDICO] Controle de documento e solicitações",
      "[JURÍDICO] Acompanhamento de prazos e alertas",
      "[SGI] Criação de RNCs e desvios através do formulário de clientes",
      "[SGI] Acompanhamento de RNCs por clientes externos",
      "[SGI] Histórico de interações com os responsáveis",
      "[SGI] Validação de ações corretivas e do plano de ações",
      "[SGI] Controle de reincidências e Eficacia das ações",
      "[BIBLIOTECA] Criação automática da estrutura de pastas",
    ],
    bug: [],
  },
  {
    versao: "3.2.1",
    data: "05/12/2024",
    melhorias: [
      "[BIBLIOTECA] Reformulação da biblioteca para controle de documentos de obra",
      "[BIBLIOTECA] Criação automática da estrutura de pastas",
      "[SGI] Refatoração do formulário de abertura de registros",
    ],
    bug: [],
  },
  {
    versao: "3.2.0",
    data: "07/11/2024",
    melhorias: ["[SGI] Melhorias no preenchimento do formulário"],
    bug: [
      "[PROJETOS] Erro na busca dos arquivos",
      "[PROJETOS] Erro na atualização dos arquivos",
    ],
  },
  {
    versao: "3.1.0",
    data: "04/11/2024",
    melhorias: [
      "[SGI] Criar registros de desvios e RNC internamente",
      "[SGI] Portal para criação de registros de desvios e RNC",
      "[SGI] Triagem de registros para atribuição de responsáveis e documentação",
      "[SGI] Controle de plano de ação e ação imediata para RNCs",
      "[RDO] Botão de edição durante a visualização do RDO",
      "[RDO] Opção de exclusão de RDO pelo administrador",
    ],
    bug: [
      "[RDO] Totais de maquinas e implementos somem durante a visualização",
      "[RDO] Comentários de imagens somem durante a visualização",
    ],
  },
  {
    versao: "3.0.4",
    data: "21/10/2024",
    melhorias: [
      "[MATERIAIS] Adicionar materiais em lote com importação do excel",
      "[MATERIAS] Como MATERIAIS quero pode excluir um material em 'elaboração'",
      "[CRE] Mostrar o status de sem data no dashboard",
      "[CRE] Enviar email para quando mudar um arquivo",
      "[CRE] Buscar o cliente e preencher no formulário",
      "[MATERIAIS] Exportar uma lista em PDF com as informações de compra",
      "[FABRICA] Cadastrar o numero SAP",
      "[RDO] Datas do cronograma sejam exportadas para PDF",
    ],
    bug: [
      "[RDO] Acumulado de horas improdutivas",
      "[MATERIAL] Margem no botão de cancelar material",
      "[MATERIAL] Problemas para liberar MATERIAIS em massa",
      "[CRE] Remover itens com status “CL” da lista e grafico de atrasados",
      "[RDO] Não permitir cadastrar diários com a mesma data quando a data é o dia atual",
      "[SISTEMA] Erro ao tentar excluir permissão de usuários que não tem conta no cognito",
      "[SISTEMA] Usuário cliente também é redirecionado para login da microsoft quando o usuário expira",
      "[RDO] As horas improdutivas não esta zerando o acumulado do mês",
    ],
  },
  {
    versao: "3.0.3",
    data: "08/10/2024",
    melhorias: [
      "[MATERIAIS] Adicionar materiais em lote com importação do excel",
      "[CRE] Envio de emails em toda atualização de arquivos",
      "[CRE] Novas regras de validação do formulário",
      "[CRE] Baixar todos os arquivos de uma vez só",
      "[CRE] Legenda dos itens do gráfico",
      "[POS VENDAS] Gráfico de custo mostrar os 10 maiores custos e o resto como acumulado",
    ],
    bug: [
      "[RDO] Acumulado de horas improdutivas",
      "[CRE] Separa projetos sem data dentro dos indicadores",
      "[SISTEMA] Mostrar nome da obra no topo da página",
      "[POS VENDAS] Email só enviado quando o processo não está finalizado",
    ],
  },
  {
    versao: "3.0.2",
    data: "10/09/2024",
    melhorias: [
      "[CRE] Link direto para projetos dentro do email",
      "[CRE] Dashboard de indicadores de projeto",
      "[CRE] Salvar versões de arquivos enviados",
      "[CRE - CLIENTES] Visualização de documentos para clientes",
      "[CRE - CLIENTES] Aprovação e reprovação de documentos pela plataforma",
      "[SEGUROS] Eventos salvos no calendário",
    ],
    bug: [
      "[Tabelas] Problemas nas buscas",
      "[RDO] Sugestão de atividades da EAP",
    ],
  },
  {
    versao: "3.0.1",
    data: "27/08/2024",
    melhorias: [
      "[SEGUROS] Visualizar data de desmobilização na tabela",
      "[PROJETOS FABRICA] Todos os comentários e mudanças de arquivos sejam salvos em formato de histórico",
      "[AUTOMACAO/COMISSIONAMENTO]  Quero receber updates caso um MARCO mude a previsão",
      "[CRE] Mudar emails para fabrica",
      "[CRE] Remover botão de upload quando em PR",
      "[CRE] Atualizar informações do email",
      "[CRE] Salvar e ordenar arquivos por data de atualização",
    ],
    bug: [
      "[Contratos] Atualizar tabela ao criar ou editar item na aba Ação",
      "[Contratos] Abrir itens no listar todos",
      "[Contratos] Gráfico não atualiza ao criar ou atualizar contratos",
      "[Seguros] Gráfico não atualiza quando cria ou atualiza um seguro",
      "[CRE] Cortando o nome do arquivo",
      "[CRE] Perda da paginação e “mostrar todo” ao abrir item",
    ],
  },
  {
    versao: "3.0.0",
    data: "16/08/2024",
    melhorias: ["[PROGALI] Lançamento do novo sistema (BETA)"],
    bug: [],
  },
  {
    versao: "2.2.3",
    data: "12/06/2024",
    melhorias: ["[PROGALI] Introdução do novo sistema (BETA)"],
    bug: [],
  },
  {
    versao: "2.2.1",
    data: "02/04/2024",
    melhorias: [
      "[PROGALI] Cadastro e controle de fabricações",
      "[RDO] Adicionar escala prevista para RDO",
      "[RDO] Aviso sobre adicionar horas paradas",
      "[RDO] Aviso sobre diário repetido",
      "[SEGUROS] Evento no calendário das 8 as 17 horas",
      "[PAPER] Imprimir observações completas",
      "[PAPER] Filtrar obras não ativas",
      "[MATERIAIS] Indicadores de pendencias",
    ],
    bug: [
      "[RDO] Problemas com configuração de RDOs",
      "[RDO] Problemas com salvamento de templates",
      "[RDO] Horas não trabalhadas não ficam salvas",
      "[RDO] Implementos não ficam salvos",
      "[PROJETO DE FABRICA] Correção da nomenclatura no sistema",
    ],
  },
  {
    versao: "2.1.1",
    data: "19/03/2024",
    melhorias: [
      "[PROJETO FABRICA] Avisos de email para mudança de status e novos comentários",
      "[CONTRATOS] Criar eventos no calendário para os vencimentos",
      "[RDO] Adicionado tabela de implementos",
      "[RDO] Controle de horas não produtivas",
      "[RDO] Visualização da data do RDO no topo da página",
      "[RDO] Adicionar comentários no registro fotográfico",
      "[PÓS VENDAS] Adicionar interações internas e externas",
      "[PÓS VENDAS] Envio de email automático nas interações externas",
    ],
    bug: [
      "[PROJETOS] Envio de asbuilt por SM",
      "[SEGUROS] Deletar evento do calendário",
    ],
  },
  {
    versao: "2.1.0",
    data: "06/03/2024",
    melhorias: [
      "[PÓS VENDAS] Integração com indicadores do SCOREPLAN",
      "[PÓS VENDAS] Tabela de gastos com field service agora possuem valores padrões",
      "[CONTRATOS] Evento adicionado ao calendário na criação de novo contrato ",
      "[PROJETO FABRICA] NOVO MÓDULO",
      "[PROJETO FABRICA] Envio de lista grande de arquivos",
      "[PROJETO FABRICA] Adicionar comentários em arquivos enviados",
      "[PROJETO FABRICA] Controle de status de projetos com histórico",
    ],
    bug: [
      "[MATERIAIS] Revisão de permissão de acesso de itens",
      "[SEGUROS] Correção de problemas com semáforo",
    ],
  },
  {
    versao: "2.0.6",
    data: "19/02/2024",
    melhorias: [
      "[PÓS VENDAS] Resposta automática para cliente no inicio de atendimento",
      "[PÓS VENDAS] Mudar email de avisos para grupo de pós vendas",
      "[PÓS VENDAS] Mais opções de upload",
      "[PÓS VENDAS] Adicionar campos de Data CAP e Vencimento da garantia",
      "[SISTEMA] Área de controle de pessoas e acessos",
      "[MATERIAIS] Gestor pode enviar item planejado SAP para revisão",
      "[CONTRATOS] Ao alterar dados de um item ele volta automaticamente para revisão",
      "[RDO] Separar tipos de mão de obra",
    ],
    bug: [
      "[PÓS VENDAS] Problemas de ordenação da tabela",
      "[SEGUROS] Problemas com casas decimais",
    ],
  },
  {
    versao: "2.0.5",
    data: "06/02/2024",
    melhorias: [
      "[PÓS VENDAS] Seleção de ano para gráficos do tipo timeline",
      "[PÓS VENDAS] Multi-filtros e ordenação para tabela",
      "[PROJETOS] Opção para selecionar qual documento deverá ser baixado",
      "[CONTRATOS] Implementação do fluxo de revisão do jurídico",
      "[CONTRATOS] Implementação do fluxo de cancelamento e finalização",
    ],
    bug: [
      "[PÓS VENDAS] Indicador de itens finalizados no último mês",
      "[SISTEMA] Itens repetidos no menu",
      "[PROJETOS] Problemas no envio de email",
      "[RDO] Problemas na unidades de medida",
      "[RDO] Subitens não são mostrados na configuração do RDO",
    ],
  },
  {
    versao: "2.0.4",
    data: "24/01/2024",
    melhorias: [
      "[PÓS VENDAS] Notificar Pós vendas e SGI de pesquisa de satisfação respondida",
      "[CLIENTES] Timeline de marcos mais coerente",
      "[CLIENTES] Area de perfil de usuário",
      "[CONTRATOS] Adicionar aba de ações",
      "[CONTRATOS] Implementar fluxo de aprovação de contrato",
      "[CONTRATOS] Controle de acesso de leitura e atualização de contratos",
    ],
    bug: ["[RDO] Remover função de rolagem em input numérico"],
  },
  {
    versao: "2.0.3",
    data: "12/01/2024",
    melhorias: [],
    bug: [
      "[MATERIAIS] Adicionar seleção de itens para liberação rápida",
      "[MATERIAIS] Página de criação de novo material não carrega",
      "[RDO] Fotos não estavam sendo exibidas na plotagem",
      "[RDO] Nome da obra e cliente não estava sendo exibido na plotagem",
      "[RDO] Comentários sendo cortados e sem formatação na plotagem de RDO",
      "[RDO] Ao criar novo RDO informações do anterior não estavam sendo carregadas",
      "[RDO] Impossibilidade de configurar novo RDO",
      "[SEGUROS] Divergência das datas de vencimento",
      "[PROJETOS] Seleção de itens por página não está funcionando",
    ],
  },
  {
    versao: "2.0.0",
    data: "08/01/2024",
    melhorias: [
      "[CONTRATOS] Controle de comodato com upload de evidencias",
      "[CONTRATOS] Controle de aditivos",
      "[CONTRATOS] Upload de contratos",
      "[CONTRATOS] SM e Responsável preenchidos automaticamente",
    ],
    bug: ["[PROJETOS] Gráfico responsivo aos filtros"],
  },
  {
    versao: "1.8.1",
    data: "28/12/2023",
    melhorias: [
      "[PROJETOS] Tabela com filtros e ordenação",
      "[SEGUROS] Gráfico responsivo aos filtros",
      "[SEGUROS] Remoção de campos não utilizados",
      "[BIBLIOTECA] Adicionar arquivos com o mesmo nome sem sobreposição",
    ],
    bug: [
      "[SEGUROS] Erros com decimais nos valores de endosso e apólice",
      "[PAPER] Correção de datas de criação",
    ],
  },
  {
    versao: "1.8.0",
    data: "12/12/2023",
    melhorias: [
      "[PROGALI CLIENTES] Lançamento do dashboard em versão beta.",
      "[PROGALI CLIENTE] Clicar em um responsável na matriz seja aberto meu provedor email",

      "[CONTRATOS] Modulo inicial com cadastro, edição, visualização e remoção de itens",
      "[PLANEJAMENTO] Alterar o cronograma não seja gerado uma nova revisão de EAP",
      "[OBRAS] Alterar uma data marco um email seja enviado para quem fez a alteração",
      "[POSVENDAS] Enviar uma nova pesquisa, responda uma aberta anterior",
    ],
    bug: [
      "[PÓS VENDAS] Problemas no envio de evidencias do clientes",
      "[BIBLIOTECA] Ordenação de pastas em ordem crescente",
    ],
  },
  {
    versao: "1.7.8",
    data: "11/11/2023",
    melhorias: [
      "[PAPER] Criar novo campo - “Impacto” com a seguinte lista de validação de dados:",
      "[PAPER] Padronizar campos:  TIPO, STATUS, ITEM, DEPARTAMENTO",
      "[PAPER] Campo cliente obrigatório para adicionar uma nova obra",
      "[PAPER] Limitar a altura máxima de anotações na tabela",
      "[PAPER] No momento da impressão, deve ter opção de imprimir: Somente última anotação OU TODAS",
      "[PAPER] Adicionar filtro na tabela",
      "[PAPER] Campos Obrigatórios com exceção de “Subitem”, “Prazo” e “Observações”",

      "[MATERIAIS] Adicionar filtro na tabela",
      "[MATERIAIS] Botão parar ir para o próximo item durante a edição",
      "[MATERIAIS] Ao enviar e-mail da LM ao quantificador, verificador ou coordenador, incluir link de acesso direto.",

      "[SGI] Avisar sobre finalização de uma pesquisa de satisfação",

      "[PROGALI] Enviar email de convite para cadastro na plataforma",
    ],
    bug: [
      "Arrumar a visualização dos itens do Prazo",
      "Sobreposição de linhas na escolha de datas no RDO",
      "Adicionar permissão de Site Manager para escrita de paper",
      "Sincronizar datas marcos em novos diários",
    ],
  },
  {
    versao: "1.7.7",
    data: "17/10/2023",
    melhorias: [
      "[ETICA] Disponibilização da Política do canal de ética",
      // "[PAPER] visualizar o autor e a data dos comentários",
      "[PAPER] Adicionar anotações como interações individuais",
      "[MATERIAIS] filtro simples e busca na lista",
      "[PROJETOS] adicionar datas no cronograma até o último nível de tarefa",
      "[PAPER] Mostrar datas revisadas na tabela",
      "[SEGUROS] Separação lógica e visual dos itens de endosso",
    ],
    bug: [
      "[MATERIAIS] Verificador não consegeue mudar o status pelo modal",
      "[MATERIAIS] Comentários devem ficar abertos em qualquer status",
      "[RDO] Correção no salvamento dos itens planejados para próximo dia e Tarefas executadas",
    ],
  },
  {
    versao: "1.7.6",
    data: "04/10/2023",
    melhorias: [
      "[PAPER] Padronização no campo DEPARTAMENTO",
      "[PAPER] Padronização no campo TIPO",
      "[PAPER] Campo PRAZO tenha um valor padrão caso vazio",
      "[PAPER] Padrão na campo STATUS",
      "[PAPER] Opção de mostrar itens finalizados",
      "[PAPER] Itens finalizados sejam ocultos por padrão",
      "[PLANEJAMENTO] Visualizar as datas planejadas no tooltip do botão",
      "[PROGALI] Disponibilizar uma tela para Clientes",
      "[PROGALI] Emails personalizados de criação de usuários",
      "[POSVENDAS] Disponibilizar o link da pesquisa de satisfação para reenvio",
    ],
    bug: [
      "[PAPER] Data de criação perdida após atualização de item",
      "[RDO] Bugs diversos na atualização de um RDO",
    ],
  },
  {
    versao: "1.7.5",
    data: "15/09/2023",
    melhorias: [
      "[OBRA] Adicionar funções a matriz de responsabilidades ",
      "[PLANEJAMENTO] Editar datas realizadas das atividades na tela de Datas Planejadas",
      "[PLANEJAMENTO] Adicionar colunas de quantidade realizada e quantidade total com números absolutos",
    ],
    bug: [
      "[PLANEJAMENTO] Atividades não registravam datas realizadas automaticamente",
    ],
  },
  {
    versao: "1.7.4",
    data: "22/08/2023",
    melhorias: [
      "[PLANEJAMENTO] Mostrar progresso acumulado e quantidade total na tela de cronograma",
      "[MATERIAIS] Controlar a data de cadastro de um novo material",
      "[MATERIAIS] Adicionar campo 'Data de necessidade' para o coordenador/ SM",
      "[OBRA] Cadastrar a matriz de responsáveis ",
      "[OBRA] Adicionar SM substituto para liberar acesso a funções do sistema",
      "[SEGUROS] Vencimento do seguro a meia noite",
      "[SEGUROS] Adicionar eventos no calendário quando um ENDOSSO  for adicionado",
      "[PAPER] Tabelas de mesmo cliente juntas",
      "[PAPER] Adicionar automaticamente o nome do cliente da OBRA",
      "[PAPER] Imprimir apenas as obras selecionadas",
      "[PROJETOS] Acesso de visualização possam baixar os documentos",
    ],
    bug: [
      "[OBRAS] Dashboard não estão mostrando as fotos mais recentes da obra",
      "[PLANEJAMENTO] Grupos do RDO não estão atualizando datas de inicio no cronograma",
    ],
  },
  {
    versao: "1.7.3",
    data: "22/08/2023",
    melhorias: [
      "[MATERIAIS] Agrupamento de materiais por CC",
      "[MATERIAIS] Fluxo completo de exclusão de materiais",
      "[MATERIAIS] Campo de coordenador de projetos automático ",
      "[PAPER] Imprimir uma obra por página",
      "[RDO] Botão para abrir RDOs em uma nova guia",
      "[SISTEMA] Indicador de filtro e ordenação aplicados em uma coluna",
    ],
    bug: [
      "[PLANEJAMENTO] Bug na curva S de São Jeronimo",
      "[PLANEJAMENTO] Visualizar todos os templates para seleção",
      "[SEGUROS] Semáforo de vencimento sendo mostrado em itens encerrados",
      "[RDO] Remoção do limite de caracteres nos comentários",
    ],
  },
  {
    versao: "1.7.2",
    data: "08/08/2023",
    melhorias: [
      "[MATERIAIS] Possibilidade de excluir materiais não planejados no SAP",
      "[PLANEJAMENTO] Exportar Curva S com indicadores de progresso",
      "[PAPER] Adicionar novos campos no cadastro",
      "[PAPER] Ordenar tabela pelo nome do cliente",
      "[PAPER] Possibilidade de excluir itens cadastrados",
      "[BIBLIOTECA] Possibilidade de excluir itens cadastrados",
    ],
    bug: [
      "[SEGUROS] Consolidar salvamento de endosso dentro do fluxo normal",
      "[SEGUROS] Aplicação de multi-filtros ",
    ],
  },
  {
    versao: "1.7.1",
    data: "25/07/2023",
    melhorias: [
      "[ÉTICA] Mostrar textos adicionados respeitando a formatação realizada no cadastro",
      "[ÉTICA] Adicionar confirmação ao solicitar interação com o usuário",
      "[RDO] Edição dos valores acumulados dentro de um RDO cadastrado",
      "[SEGUROS] Adicionado filtro de itens pela coluna",
      "[BIBLIOTECA] Adicionado controle e filtro de acessos",
    ],
    bug: [
      "[RDO] Problemas no cadastro de templates após exclusão de grupos",
      "[RDO] Impedir atualização de data de último RDO durante alteração de cronograma",
      "[SEGUROS] Remover status 'RENOVADO'",
      "[MATERIAIS] Correção das permissões de acesso para alteração de itens",
    ],
  },
  {
    versao: "1.7.0",
    data: "12/07/2023",
    melhorias: [
      "[PAPER] Tela para gerenciar os documentos e eventos de obra",
      "[PAPER] Exportar tabelas por obras",
      "[ÉTICA] Respostas padrões ao finalizar uma denúncia",
      "[ÉTICA] Validação do formulário de denúncias",
      "[POSVENDAS] Avaliação na pesquisa de satisfação por números de 1 a 10   ",
      "[DATAS MARCOS] quero poder editar os itens do histórico",
      "[MATERIAIS] SM e Coordenador são preenchidos automaticamente",
      "[MATERIAIS] Unidades padronizadas",
    ],
    bug: [
      "[SEGUROS] Separação de sessões dentro dos detalhes do seguro",
      "[SEGUROS] Filtros de obras encerradas e seguros finalizados",
      "[SEGUROS] Nome do projeto é mostrado ao invés da obra",
      "[SEGUROS] Arrumar as casas decimais nos valores  ENDOSSO",
      "[SEGUROS] Numeração automática na lista de endosso",
      "[SISTEMA] Tabela RDO está mudando a cor ",
    ],
  },
  {
    versao: "1.6.2",
    data: "26/06/2023",
    melhorias: [
      "[MATERIAIS] Cancelamento de itens já planejados",
      "[MATERIAIS] Emails de itens em revisão",
      "[MATERIAIS] Configuração de colunas a exibir",
      "[MATERIAIS] Menu lateral colapsável",
      "[MATERIAIS] Adicionado campos de PCP",
      "[MATERIAIS] Adicionado validação de itens ao mudar de status",
      "[SEGUROS] Controle ilimitado de itens de endosso",
      "[SEGUROS] Correções de colunas (remoção e atualização de nomenclatura) ",
      "[SEGUROS] Melhorias no design dos detalhes de seguros",
      "[SEGUROS] Semáforo para datas dos vencimentos dos seguros",
      "[SEGUROS] Botão de aviso para obras com validadores incompleto",
      "[CANAL DE ÉTICA] Separação de denúncias por status (Aberto, Em andamento, Finalizada)",
    ],
    bug: [
      "[RDO] Adição de novas unidades de medidas e efetivos",
      "[CANAL DE ÉTICA] Correção de textos",
      "[MATERIAIS] Melhoria no controle das permissões",
    ],
  },
  {
    versao: "1.6.1",
    data: "19/06/2023",
    melhorias: [
      "[MATERIAIS] Enviar itens para revisão",
      "[MATERIAIS] Envio de emails sobre mudança de status de itens",
      "[MATERIAIS] Após a revisão de um item, ele é enviado novamente para aprovação",
      "[MATERIAIS] Tela para criação e configuração de templates",
      "[PÓS-VENDAS] Adicionado caixa de diálogo ao sair da aba sem salvar",
      "[PLANEJAMENTO] REFATORAR CURVA S PARA SOMATÓRIA E NÃO MEDIA PONDERADA",
      "[ARQUIVO] Módulo de controle de arquivos gerais da obra, com adição de arquivos e pastas",
      "[ARQUIVO] Busca de arquivos dentro de pastas pelo nome",
    ],
    bug: [
      "[CANAL DE ÉTICA] Correção de alguns textos",
      "[CANAL DE ÉTICA] Problemas nas buscas de interações e arquivos",
      "[CANAL DE ÉTICA] Adicionar indicadores de carregamento e sucesso de operações",
      "[SEGUROS] Status do item não mostrando o vencimento",
      "[SEGUROS] Campo de observação não aparece na tabela",
      "[SEGUROS] Botão de salvar não estava redirecionando",
      "[PÓS-VENDAS] Problemas ao adicionar interações com ticket",
    ],
  },
  {
    versao: "1.6.0",
    data: "01/06/2023",
    melhorias: [
      "[MATERIAIS] MVP do sistema com a primeira fase de implementação sem integração com MRP",
      "[MATERIAIS] Liberar vários itens ao mesmo tempo",
      "[MATERIAIS] Visualizar todos os materiais de uma obra, separado por CC e área",
      "[MATERIAIS] Colocar itens em REVISÃO",
      "[CANAL DE ÉTICA] Formulário para denúncias",
      "[CANAL DE ÉTICA] Página para baixar o código de ética da empresa",
      "[CANAL DE ÉTICA] Página para denunciante consultar denúncias",
      "[CANAL DE ÉTICA] Sistema para acompanhamento e controle de denúncias",
      "[CANAL DE ÉTICA] Emails sobre novas denúncias e atualizações para a equipe de ética",
      "[CANAL DE ÉTICA] Possibilidade de fazer interações e devolutiva das denúncias dentro da plataforma",
      "[CANAL DE ÉTICA] Upload de documentos nas interações durante a denúncia",
      "[OBRAS] Campo de justificativa de alteração de marco pré formatado, para estabelecer um padrão de preenchimento",
      "[OBRAS] Número de revisão de datas marcos seja mostrado no formulário",
      "[PLANEJAMENTO] Seleção e visualização de todo o histórico de alterações de cronograma, na página de datas planejadas",
      "[PÓS-VENDAS] Adicionado coluna de data de abertura do chamado NA TABELA",
      "[PÓS-VENDAS] A finalizar um ticket o status dele seja alterado para 'Concluído'",
      "[PÓS-VENDAS] Tela de atualização automática para acompanhamento dos tickets, na TV",
      "[PROJETOS] Ao cadastrar um novo item dentro de uma categoria ela já seja autopreenchida",
      "[SEGUROS] Filtrar obras finalizadas e seguros encerrados",
      "[SEGUROS] Possibilidade de visualizar a lista de endossos nos detalhes do item",
      // '[CANAL DE ÉTICA] quero ser indicado quando uma ação estivar sendo executada(loading)',
      // '[ CANAL DE ÉTICA] quero ser avisado quando acessar uma rota não existente',
      // '[CANAL DE ÉTICA] quero fazer upload de documentos comprovantes'
    ],
    bug: [
      "[SEGUROS] Substituir vigência fim e inicio por aquisição do endosso",
      "[RDO] Arredondamento do campo pluviosidade para 2 dígitos de arredondamento após a virgula.",
      "[RDO] MELHORAR EMAIL DE ATRASO EM RDO",
    ],
  },
  {
    versao: "1.4.3",
    data: "18/04/2023",
    melhorias: [
      "[PÓS-VENDAS] Salvar o responsável do ticket durante a finalização",
      "[PÓS-VENDAS] Remoção dos email da equipe interna, nas pesquisas de satisfação",
      "[PÓS-VENDAS] Reformulação das perguntas da pesquisa de satisfação",
      "[PÓS-VENDAS] Filtrar tickets por intervalo de datas",
      "[PÓS-VENDAS] Visualização do resultado da pesquisa de satisfação, dentro das informações do ticket",
      "[PROJETOS] Adicionado gráficos no dashboard internos de obras",
      "[RDO] Indicativo visual de inconformidades na configuração do RDO",
      "[OBRAS] Botão para alerta automático",
      "[RDO] Indicativo visual de inconformidades na configuração do RDO",
      "[OBRAS] Botão de alerta automático para obras com RDO em atraso ",
    ],
    bug: ["[RDO] Correção de problemas na alteração de configurações do RDO"],
  },
  {
    versao: "1.4.2",
    data: "11/04/2023",
    melhorias: [
      "[PÓS-VENDAS] Envio de pesquisa de satisfação automático ao finalizar um ticket",
      "[PÓS-VENDAS] Adicionar campo de responsável de obra na abertura de ticket",
      "[CRONOGRAMA] Adicionado cabeçalho com informações da obra na tela de cronograma",
      "[CRONOGRAMA] Adicionado número de revisão de cronograma",
      "[CRONOGRAMA] Na tela de cronograma agora são sinalizados os atrasos e finalizações",
      "[CRONOGRAMA] Adicionado coluna de desvios de datas",
    ],
    bug: [
      '[OBRAS] O campo "data do último diário" agora reflete todas exclusões e modificações do RDO',
      "[CRONOGRAMA] A busca do RDO da ultima semana busca o RDO mais recente",
      "[CRONOGRAMA] Mostrar os números da semana do ano no gráfico",
      "[PÓS-VENDAS] Correção nas cores do gráfico, respeitando semáforo estalecido",
      "[PÓS-VENDAS] Janela de revisão de informações antes da finalização de um ticket",
      "[SISTEMA] Adicionado botão de scroll down e scroll up",
    ],
  },
  {
    versao: "1.4.1",
    data: "20/03/2023",
    melhorias: [
      "[CRONOGRAMA] Visualização da tabela de cronograma",
      "[PÓS-VENDAS] Relatórios de tickets agora mostram números de tickets por responsabilidade",
      "[PROJETOS] Adicionado campo de coordenador e categoria de projetos",
      "[PROJETOS] Separação entre EPO e EPF",
      "[PROJETOS] Paginas especificas para cada tipo de projeto (EXECUTIVO, AS BUILT e REFERÊNCIA)",
    ],
    bug: [
      "[PÓS-VENDAS] Correção no calculo de gastos de tickets",
      "[PÓS-VENDAS] Campo de inicio de operação não é mais obrigatório",
      "[SEGUROS] Eventos de vencimento agora são de dia inteiro",
      "[OBRAS] Alteração de datas e exclusão de RDOs agora atualizam a tela principal",
    ],
  },
  {
    versao: "1.4.0",
    data: "14/03/2023",
    melhorias: [
      "[CRONOGRAMA] Controle de datas de inicio e fim de atividades do RDO",
      "[CRONOGRAMA] Visualização da curva S da obra",
      "[CRONOGRAMA] Filtro de datas para o calendário de marcos de obra",
      "[PÓS-VENDAS] Opção para deletar tickets cadastrados",
      "[PROJETOS] Gráficos específicos para EPF e EPO",
      "[SISTEMA] Tela com informações sobre todas a atualizações",
      "[RH] Campo de busca de colaboradores em RH",
    ],
    bug: [
      '[OBRAS] Alterar nomenclatura de "data finalizada" para "etapa concluída" na atualização de marcos',
      "[PROJETOS] Correção das permissões de acesso aos documentos de as built",
      "[SEGUROS] Validação da deleção de um seguro",
      "[SISTEMA] Dessincronia  na atualização de tela durante ordenação de listas",
    ],
  },
  {
    versao: "1.3.4",
    data: "21/02/2023",
    melhorias: [
      "[PÓS-VENDAS] Novo gráfico de indicadores de atraso.",
      "[PÓS-VENDAS] Opção para sinalizar atendimentos internos.",
      "[PÓS-VENDAS] Opção de manter ou mudar data de próxima interação.",
      "[PÓS-VENDAS] Indicadores de gestão a vista.",
      "[PÓS-VENDAS] Opção de abrir ticket na nova guia.",
      "[PÓS-VENDAS] Adicionar lista de obras já controladas para auto-preenchimento.",
      "[OBRAS] Exportação da tabela inicial.",
      "[OBRAS] Opção de sinalizar um marco de obra como finalizado.",
      "[OBRAS] Calendário com datas marcos gerado automaticamente.",
      "[OBRAS] Emails mais completo de alteração de marcos.",
      "[OBRAS] Adicionar data de start-up.",
      "[OBRAS] Visualizar marcos finalizados na tela inicial.",
      "[RDO] Nova versão de cabeçalho.",
    ],
    bug: [
      "[PÓS-VENDAS] Modal de confirmação agora aparece ao tentar finalizar um ticket sem data de conclusão.",
      '[PÓS-VENDAS] Nome da coluna "custo material" mudou para "Adicionais".',
      "[PÓS-VENDAS] Menores: Nome da categoria agora é editável, os items de controle de custos podem ser adicionados e removidos, todos os status estão sendo mostrados no gráfico e agora é possível ordenar a data de finalização.",
      '[RDO] Adicionado "Técnico de automação" a lista de funções disponíveis.',
      "[OBRAS] Datas agora são mostradas em ordem cronológica na tabela inicial",
      "[OBRAS] Correção de espaçamento das colunas da tela inicial.",
      "[PROJETOS] Reativado os avisos de projeto aprovado, via teams e email para SM.",
    ],
  },
];

export default versoes;
// export default versoes;
